export const townshipList = [
  { label: '北史家务镇', value: '001' },
  { label: '龙河高新区', value: '002' },
  { label: '杨税务镇', value: '003' },
  { label: '落垡镇', value: '004' },
  { label: '仇庄镇', value: '005' },
  { label: '码头镇', value: '006' },
  { label: '葛渔城镇', value: '007' },
  { label: '东沽港镇', value: '008' },
  { label: '调河头镇', value: '009' }
]

export const warningStatus = [
  { label: '研判', value: 0 },
  { label: '签收中', value: 1 },
  { label: '处置中', value: 2 },
  { label: '审核中', value: 3 },
  { label: '预警关闭', value: 4 },
  { label: '预警解除', value: 5 },
  { label: '申诉通过', value: 6 },
]
